<template >
  <boxDropDown title="Configurar H.E Noturna e Diurna">
    <template class="support-tools">
      <div class="form-group col-md-12 support-tools__warning">
        <span>
          <b>
            Atenção:
          </b>
            Se ignorar a troca de dia não estiver marcada, significa que jornadas que são interdiárias
            e que possuem horas extras serão divididas e recalculadas dependendo do dia em que a jornada foi feita, exemplo: Turno 08:00 - 12:00 - 13:00 - 21:00,
            se minha jornada começou 08:00 e finalizou 03:00 do outro dia, o que foi hora extra até 00:00 será calculada de acordo com a configuração feita do dia do início da jornada 
            e após 00:00 da configuração do dia seguinte.
        </span>
      </div>


      <div class="form-group col-md-12">
        <label for="companyId">CompanyId</label>
        <input type="text" class="form-control" v-model="companyId" placeholder="ID da empresa" id="companyId">
      </div>

      <div class="col-md-12">
              <input type="checkbox" id="ignoreDayChange" v-model="ignoreDayChange">
              <label for="">Ignorar a troca de dia?</label>
      </div>
      
      <div class="form-group col-md-12">
        <div class="diurne form-group col-md-12">
          <p class="text-center"><strong>Configurar H.E Diurna</strong></p>
          <div class="form-group col-md-6">
            <label for="firstPhase">Primeira fase (H.E 1)</label>
            <input type="number" class="form-control" v-model="diurneFirstPhase" placeholder="Por exemplo 80" id="firstPhase" min="1" max="3" v-mask="['###']">
          </div>
          <div class="form-group col-md-6">
            <label for="secondPhase">Segunda fase (H.E 2)</label>
            <input type="number" class="form-control" v-model="diurneSecondPhase" placeholder="Por exemplo 100" id="secondPhase" min="1" max="3" v-mask="['###']">
          </div>
          <div v-for="dayOfWeek in daysOfWeek" class="col-md-12 dayOfWeek">
            <div class="col-md-4 dayOfWeek__text">{{ dayOfWeek.day }}</div>
            <div class="col-md-4">
              <input v-bind:disabled="dayOfWeek.daily.usehe2" type="checkbox" id="" class="checkbox-overtimes" v-model="dayOfWeek.daily.usehe1">
              <label for="">H.E.1</label>
            </div>
            <div class="col-md-4">
              <input v-bind:disabled="dayOfWeek.daily.usehe1" type="checkbox" id="" class="checkbox-overtimes" v-model="dayOfWeek.daily.usehe2">
              <label for="">H.E.2</label>
            </div>
          </div>
        </div>
        
        <!-- <div><span class="separator"></span></div> -->

        <div class="nocturne form-group col-md-12">
          <p class="text-center"><strong>Configurar H.E Noturna</strong></p>
          <div class="form-group col-md-6">
            <label for="firstPhase">Primeira fase (H.E 1)</label>
            <input type="number" class="form-control" v-model="nocturneFirstPhase" placeholder="Por exemplo 80" id="firstPhase" min="1" max="3" v-mask="['###']">
          </div>
          <div class="form-group col-md-6">
            <label for="secondPhase">Segunda fase (H.E 2)</label>
            <input type="number" class="form-control" v-model="nocturneSecondPhase" placeholder="Por exemplo 100" id="secondPhase" min="1" max="3" v-mask="['###']">
          </div>
          <div v-for="dayOfWeek in daysOfWeek" class="col-md-12 dayOfWeek">
            <div class="col-md-4 dayOfWeek__text">{{ dayOfWeek.day }}</div>
            <div class="col-md-4">
              <input v-bind:disabled="dayOfWeek.night.usehe2" type="checkbox" class="checkbox-overtimes" id="" v-model="dayOfWeek.night.usehe1">
              <label for="">H.E.1</label>
            </div>
            <div class="col-md-4">
              <input v-bind:disabled="dayOfWeek.night.usehe1" type="checkbox" id="" class="checkbox-overtimes" v-model="dayOfWeek.night.usehe2">
              <label for="">H.E.2</label>
            </div>
          </div>
        </div>

        <div class="send-button form-group col-md-12">
          <button class="btn btn-primary" :disabled="loadindConfigureOvertime" @click="sendConfigureOvertime()">
            <span v-if="!loadindConfigureOvertime">Enviar</span>
            <span v-else class="loading-btn">
              <div class="spinner-btn">
                <div class="rect1"></div>
                <div class="rect2"></div>
                <div class="rect3"></div>
                <div class="rect4"></div>
                <div class="rect5"></div>
              </div>
            </span>
          </button>
        </div>

      </div>
    </template>
  </boxDropDown>
</template>

<script>
  import boxDropDown from "../../../components/layouts/boxDropDown.vue";
  import {
    REQUEST_SERVICE
  } from "../../../../../requestConfig";
  import {
    ALERT_SERVICE
  } from "../../../../../msgAlertService";
  import {
    CONTEXT_COMPANY,
    CONFIGURE_OVERTIME,
  } from "../../../../../urlConfig";


  export default {
    name: "configureOvertime",
    components: {
      boxDropDown,
    },
    data() {
      return {
        companyId: undefined,
        loadindConfigureOvertime: false,
        daysOfWeek: [
          {
            day: "Segunda",
            type: 1,
            daily: {
              usehe1: false,
              usehe2: false
            },
            night: {
              usehe1: false,
              usehe2: false
            }
          },
          {
            day: "Terça",
            type: 2,
            daily: {
              usehe1: false,
              usehe2: false
            },
            night: {
              usehe1: false,
              usehe2: false
            }
          },
          {
            day: "Quarta",
            type: 3,
            daily: {
              usehe1: false,
              usehe2: false
            },
            night: {
              usehe1: false,
              usehe2: false
            }
          },
          {
            day: "Quinta",
            type: 4,
            daily: {
              usehe1: false,
              usehe2: false
            },
            night: {
              usehe1: false,
              usehe2: false
            }
          },
          {
            day: "Sexta",
            type: 5,
            daily: {
              usehe1: false,
              usehe2: false
            },
            night: {
              usehe1: false,
              usehe2: false
            }
          },
          {
            day: "Sábado",
            type: 6,
            daily: {
              usehe1: false,
              usehe2: false
            },
            night: {
              usehe1: false,
              usehe2: false
            }
          },
          {
            day: "Domingo",
            type: 0,
            daily: {
              usehe1: false,
              usehe2: false
            },
            night: {
              usehe1: false,
              usehe2: false
            }
          },
          {
            day: "Feriado",
            type: 7,
            daily: {
              usehe1: false,
              usehe2: false
            },
            night: {
              usehe1: false,
              usehe2: false
            }
          }
        ],
        nocturneFirstPhase: undefined,
        nocturneSecondPhase: undefined,
        diurneFirstPhase: undefined,
        diurneSecondPhase: undefined,
        contentSetting: "",
        ignoreDayChange: false
      }
    },
    methods: {
      sendConfigureOvertime(){
        if(this.companyId === undefined || !this.companyId.length || this.companyId.length !== 32){
          ALERT_SERVICE.swal("Aviso", "Preencha o ID da empresa corretamente", "warning");
          return;
        }

        if(this.daysOfWeek.some(x => (!x.daily.usehe1 && !x.daily.usehe2) || (!x.night.usehe1 && !x.night.usehe2))){
          ALERT_SERVICE.swal("Aviso", "Por favor, realize todas as configurações das H.E's diurnas e noturnas antes de continuar", "warning");
          return;
        }

        //Possiblitar valores 0 para a separação
        if(this.nocturneFirstPhase === undefined || this.nocturneSecondPhase === undefined || this.diurneFirstPhase === undefined || this.diurneSecondPhase === undefined){
          ALERT_SERVICE.swal("Aviso", "Por favor, preencha todas as porcentagens antes de prosseguir", "warning");
          return;
        }

        if(this.nocturneFirstPhase > 300 || this.nocturneSecondPhase > 300 || this.diurneFirstPhase > 300 || this.diurneSecondPhase > 300){
          ALERT_SERVICE.swal("Aviso", "As porcentagens são inválidas", "warning");
          return;
        }
        this.loadindConfigureOvertime = true;

        let bodyRequest = this.getBodyToSendConfigureOvertime();

        REQUEST_SERVICE.get(`${CONTEXT_COMPANY}${this.companyId}`).then((response) => {
          this.contentSetting = response.data;
          let bodyRequestJSON = JSON.stringify(bodyRequest);

          REQUEST_SERVICE.requestContext('POST', CONFIGURE_OVERTIME, this.contentSetting, bodyRequestJSON).then((response) => {
            ALERT_SERVICE.swal("Sucesso", "Configuração feita com sucesso!", "success");
            this.clearFields();
            this.loadindConfigureOvertime = false;
          }).catch((reason) => {
            this.loadindConfigureOvertime = false;
            if(reason.response && reason.response.data.erros.length > 0){
              ALERT_SERVICE.swal("ERRO", reason.response.data.erros[0].value, "error");
            }else{
              ALERT_SERVICE.swal("ERRO", "Entre em contato com a equipe de produto", "error");
            }
          });
        }).catch((reason) => {
          this.loadindConfigureOvertime = false;
          ALERT_SERVICE.swal("ERRO", "Entre em contato com a equipe de produto", "error");
        });
      },
      clearFields(){
        this.companyId = undefined;
        this.contentSetting = "";
        this.loadindConfigureOvertime = false;
        this.daysOfWeek = [
          {
            day: "Segunda",
            type: 1,
            daily: {
              usehe1: false,
              usehe2: false
            },
            night: {
              usehe1: false,
              usehe2: false
            }
          },
          {
            day: "Terça",
            type: 2,
            daily: {
              usehe1: false,
              usehe2: false
            },
            night: {
              usehe1: false,
              usehe2: false
            }
          },
          {
            day: "Quarta",
            type: 3,
            daily: {
              usehe1: false,
              usehe2: false
            },
            night: {
              usehe1: false,
              usehe2: false
            }
          },
          {
            day: "Quinta",
            type: 4,
            daily: {
              usehe1: false,
              usehe2: false
            },
            night: {
              usehe1: false,
              usehe2: false
            }
          },
          {
            day: "Sexta",
            type: 5,
            daily: {
              usehe1: false,
              usehe2: false
            },
            night: {
              usehe1: false,
              usehe2: false
            }
          },
          {
            day: "Sábado",
            type: 6,
            daily: {
              usehe1: false,
              usehe2: false
            },
            night: {
              usehe1: false,
              usehe2: false
            }
          },
          {
            day: "Domingo",
            type: 0,
            daily: {
              usehe1: false,
              usehe2: false
            },
            night: {
              usehe1: false,
              usehe2: false
            }
          },
          {
            day: "Feriado",
            type: 7,
            daily: {
              usehe1: false,
              usehe2: false
            },
            night: {
              usehe1: false,
              usehe2: false
            }
          }
        ];
        this.nocturneFirstPhase = undefined;
        this.nocturneSecondPhase = undefined;
        this.diurneFirstPhase = undefined;
        this.diurneSecondPhase = undefined;
        this.ignoreDayChange = false;
      },
      getBodyToSendConfigureOvertime(){
        let daysConfig = [];
        this.daysOfWeek.forEach((day) => {
          daysConfig.push({
            dayType: day.type,
            dayOvertimeType: day.daily.usehe1 ? 1 : 2,
            nightOvertimeType: day.night.usehe1 ? 1 : 2 
          });
        });
        return {
          DayOvertimeIsActive: true,
          NightOvertimeIsActive: true,
          DayOvertimeFirstPhasePercentage: this.diurneFirstPhase / 100,
          DayOvertimeSecondPhasePercentage: this.diurneSecondPhase / 100,
          NightOvertimeFirstPhasePercentage: this.nocturneFirstPhase / 100,
          NightOvertimeSecondPhasePercentage: this.nocturneSecondPhase / 100,
          IgnoreDayChange: this.ignoreDayChange,
          CompanyId: this.companyId,
          WorkShiftOvertimeSettingsDayCommand: daysConfig
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  * {
    font-family: "Montserrat", sans-serif !important;
  }

  .dayOfWeek{
    display: flex !important;
    justify-content: space-between !important; 
    text-align: center;
    margin-bottom: 10px;

    &__text{
      text-align: start;
    }
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type=number] {
    -moz-appearance: textfield;
  }

  .diurne, .nocturne{
    border: 3px solid rgba(0, 0, 0, 0.062) !important;
    border-radius: 10px !important;
    padding: 20px;
  }

  .send-button{
    display: flex;
    justify-content: center;
  }

  .support-tools {
    &__warning {
      padding: 10px;
      text-align: center;
      background-color: #FFDF8D;
      border-radius: 8px !important;
      color: #FF445D;
    }
  }

  .checkbox-overtimes{
    width: 15px;
    height: 15px;
  }
</style>


// WEBPACK FOOTER //
// src/vue/pages/restricted/support/supportItems/configureOvertime.vue